import { renderCustomElements } from 'js/customForm'
import { renderCustomSelect } from 'js/customSelect'

window.renderCustomElements = renderCustomElements
window.renderCustomSelect = renderCustomSelect
